import { WifiOff } from 'lucide-react';

export function OfflineBanner() {
  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-red-900/90 text-white text-center py-2 text-sm flex items-center justify-center gap-2">
      <WifiOff className="w-4 h-4" />
      API Offline -- Start Docker: <code className="bg-red-800 px-2 py-0.5 rounded text-xs">docker compose up -d</code>
    </div>
  );
}
